import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.tiendadigitalonline.com/cart/47950473298161:1';
export function PricingSection() {
  return <section id="compra" className="w-full bg-white py-16 md:py-20 px-4" data-id="element-222">
      <div className="max-w-3xl mx-auto text-center" data-id="element-223">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-10" data-id="element-224">
          📦 Lo que recibís hoy
        </h2>

        {/* Checklist */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-10 text-left max-w-xl mx-auto mb-10 border border-gray-100" data-id="element-225">
          <div className="space-y-4" data-id="element-226">
            <div className="flex items-start gap-3" data-id="element-227">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-228" />
              <p className="font-body text-gray-800 text-lg" data-id="element-229">
                Ebook completo Tarot y Autoconocimiento
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-230">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-231" />
              <p className="font-body text-gray-800 text-lg" data-id="element-232">
                Diario de 30 días
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-233">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-234" />
              <p className="font-body text-gray-800 text-lg" data-id="element-235">
                Guía de limpieza energética
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-236">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-237" />
              <p className="font-body text-gray-800 text-lg" data-id="element-238">
                Tarot y manifestación
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-239">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-240" />
              <p className="font-body text-gray-800 text-lg" data-id="element-241">Mazo imprimible</p>
            </div>
            <div className="flex items-start gap-3" data-id="element-242">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-243" />
              <p className="font-body text-gray-800 text-lg" data-id="element-244">
                Meditación guiada
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-245">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-246" />
              <p className="font-body text-gray-800 text-lg" data-id="element-247">
                Acceso inmediato
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-248">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-249" />
              <p className="font-body text-gray-800 text-lg" data-id="element-250">Descarga en PDF</p>
            </div>
            <div className="flex items-start gap-3" data-id="element-251">
              <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-252" />
              <p className="font-body text-gray-800 text-lg" data-id="element-253">
                Acceso de por vida
              </p>
            </div>
          </div>
        </div>

        {/* Price */}
        <div className="mb-10" data-id="element-254">
          <p className="font-body text-gray-500 text-lg mb-2" data-id="element-255">
            💰 Precio regular:
          </p>
          <p className="font-heading font-bold text-3xl text-gray-400 line-through mb-4" data-id="element-256">
            ARS $49.990
          </p>
          <div className="inline-block bg-urgency-600 text-white px-6 py-3 rounded-lg mb-2" data-id="element-257">
            <p className="font-heading font-bold text-lg" data-id="element-258">🔥 HOY SOLO:</p>
          </div>
          <p className="font-heading font-bold text-5xl md:text-6xl text-urgency-600 mt-2" data-id="element-259">
            ARS $19.990
          </p>
        </div>

        {/* CTA */}
        <a href={CHECKOUT_URL} className="inline-flex items-center gap-3 bg-gradient-to-r from-gold-500 to-gold-600 text-black font-heading font-bold text-xl md:text-2xl px-10 md:px-14 py-5 md:py-6 rounded-xl animate-pulse-glow hover:from-gold-400 hover:to-gold-500 transition-all duration-300 uppercase tracking-wide shadow-2xl" data-id="element-260">
          <ZapIcon className="w-7 h-7" data-id="element-261" />
          👉 OBTENER MI CURSO AHORA
        </a>

        <p className="font-body text-gray-500 text-sm mt-6" data-id="element-262">
          Pago seguro · Acceso inmediato · Garantía de 7 días
        </p>
      </div>
    </section>;
}